import React, { useRef, useState, useEffect, useContext } from 'react';
import useOnScreen from '../../../hooks/useOnScreen';
import { FilterContext } from '../../../context/FilterContext';
import { Navigate } from 'react-router-dom';

function Lampara({ data, index, delay }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);
  const [redir, setRedir] = useState('');
  const fi = useContext(FilterContext);
  useEffect(() => {
    if (isVisible && !show) {
      setShow(true);
    }
  }, [isVisible]);
  return (
    <>
      {data.nombre === 'AR1111' ? (
        <div
          className={`basis-full  transition-all duration-500 ease-in p-1 ${delay} md:text-left box-border md:basis-1/4 text-left  ${
            show ? 'translate-y-0 opacity-100' : 'translate-y-1/4 opacity-0'
          }`}
          ref={ref}
        >
          <div className="w-full overflow-hidden relative">
            <img
              className="transition-transform duration-500 hover:scale-110"
              src={require(`../../../assets/images/lamparas/${data.imagen}`)}
            />
            <div className="absolute top-0 right-0 w-full h-full bg-black/70 flex items-center justify-center">
              <p className="text-black text-lg m-auto text-center bg-white basis-full">
                Proximamente
              </p>
            </div>
          </div>
          <span className="py-4 block font-light text-lg">{data.nombre}</span>
        </div>
      ) : (
        <div
          onClick={(e) => {
            fi.dispatch({
              type: 'set_lamparas_filter',
              payload: { lamparas: [data.id] },
            });

            setRedir('/productos');
          }}
          ref={ref}
          className={`basis-full  transition-all duration-500 ease-in p-1 ${delay} md:text-left box-border md:basis-1/4 text-left  ${
            show ? 'translate-y-0 opacity-100' : 'translate-y-1/4 opacity-0'
          }`}
        >
          {redir && <Navigate to={redir} replace />}

          <div className="w-full overflow-hidden">
            <img
              className="transition-transform duration-500 hover:scale-110"
              src={require(`../../../assets/images/lamparas/${data.imagen}`)}
            />
          </div>
          <span className="py-4 block font-light text-lg">{data.nombre}</span>
        </div>
      )}
    </>
  );
}
export default Lampara;
